// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum FrameType {
  unknown = 0,
  login = 1,
  statusRequest = 2,
  secureCCResponse = 3,
  changeRequest = 4,
  statusResponse = 5,
  commandRequest = 6,
}
